import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { UtilServico } from '../servicos/util.servico';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilDadosLogado } from '../servicos/util.logado';

@Injectable()
export class LoginServico {
    constructor(
        private http: Http,
        private router: Router,
        private UtilServico: UtilServico,
        public UtilDadosLogado: UtilDadosLogado
    ) { }
   
    login(usuario: string, senha: string) {
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8'});
        let options = new RequestOptions({ headers: headers });
        
         return this.http.post(this.UtilDadosLogado.DadosAcesso().URL +"/api/Login/Autenticar", JSON.stringify({ usuario: usuario, senha: senha }), options)
            .map((response: Response) => {
                let dados = response.json()[0];
                if (dados && dados.token) {                   
                    //console.log(dados.token);
                    //localStorage.setItem('Token', JSON.stringify(dados.token));
                    localStorage.setItem('AcessoAdm', JSON.stringify(dados));
                }
            });
    }

    logout() {
        localStorage.removeItem('AcessoAdm');
        this.router.navigate(['/inicial']);
    }

}


// WEBPACK FOOTER //
// D:/Agents/es/_work/11/s/ANGULAR/src/app/servicos/login.servico.ts